/**
 * Available options for the journal line description
 */
export enum WorkAppJournalLineDescriptionBehaviour {
  FromJob,
  FromPhase,
  Empty,
}
